<template>
  <div class="campaign-edit-content medium-8 columns divider-vertical">
    <slot name="groups"></slot>
    <slot name="selectedViewToggle"></slot>
    <div class="campaign-content">
      <toggle-section-slide
          key="sms"
          :shouldOpen="smsSend"
          toggleText="text content"
          toggleTextClasses="text-link"
          :wrapperClasses="smsWrapperClasses"
          @onToggleTextClick="$emit('toggleSend', 'sms')">

        <div slot="mainContent">
          <message
            :campaign="campaign"
            :active-message="true"
            :campaignSendTime="campaignSendTime"
            :smsSend="smsSend"
            @update="updateCampaign">
          </message>

          <text-notification-picker v-if="!classicCampaignsEnabled" :selected="selectedNotificationTemplate" v-on:update:selected="updatedSelectedNotification" :templates="getCampaignNotificationTemplates" />

          <div class="data-description">
            <b>credit summary</b>

            <div>
              characters {{ characterCount }}, credits {{ totalCredits }}
            </div>
          </div>
        </div>

        <!--<toggle-section-slide
            v-if="!merchantCountryIsCanada"
            slot="extraContent"
            key="backup"
            :shouldOpen="showBackup"
            toggleText="optimize campaign deliverability"
            toggleTextClasses="backup-campaign__toggle-text"
            wrapperClasses="backup-campaign"
            @onToggleTextClick="$emit('setShowBackupStatus', !showBackup)">
          <campaign-backup-edit
              slot="mainContent"
              :parentId="campaignId"
              :showBackup="showBackup"
              :shouldCancelBackup="shouldCancelBackup"
              :smsSend="smsSend">
          </campaign-backup-edit>
        </toggle-section-slide>-->
      </toggle-section-slide>

      <toggle-section-slide
          key="email"
          :shouldOpen="emailSend"
          toggleText="email content"
          toggleTextClasses="email-link"
          :wrapperClasses="emailWrapperClasses"
          @onToggleTextClick="$emit('toggleSend', 'email')">
        <campaign-email
            slot="mainContent"
            :email="email"
            :emailSend="emailSend"
            @updateEmail="updateCampaign">
        </campaign-email>
      </toggle-section-slide>
    </div>

    <slot name="scheduler"></slot>
  </div>
</template>


<script>
  import CampaignBackupEdit from './CampaignBackupEdit'
  import CampaignEmail from '../../components/Campaigns/CampaignEmail'
  import { mapGetters, mapActions, mapState } from 'vuex'
  import Message from '../../components/Message/index'
  import ToggleSectionSlide from '../../components/shared/ToggleSectionSlide'
  import TextNotificationPicker from "../TextNotificationPicker";

  export default {
    props: {
      campaign: Object,
      backupCampaignIds: Array,
      campaignId: [Number, String],
      campaignSendTime: String,
      email: Object,
      emailSend: Boolean,
      sendAtLocal: String,
      selectedView: String,
      sendBackup: Boolean,
      shouldCancelBackup: Boolean,
      showBackup: Boolean,
      smsSend: Boolean,
    },

    name: 'CampaignCreationContent',

    components: {
      CampaignBackupEdit,
      CampaignEmail,
      Message,
      ToggleSectionSlide,
      TextNotificationPicker
    },

    data() {
      return {
        backupCampaignId: null,
        selectedNotification: null
      }
    },

    methods: {
      initBackupMessageModule() {
        this.backupCampaignId = this.backupCampaignIds ? this.backupCampaignIds[0] : null
        this.UPDATE_BOOLEAN_STATUS({stateKey: 'isBackup', status: true})
        if (this.backupCampaignId) {
          this.UPDATE_MESSAGE_ID_TYPE({messageId: this.backupCampaignId, messageType: 'Campaign'})
          this.$emit('setShowBackupStatus', true)
        }
      },

      updateCampaign(dataToUpdate) {
        this.$emit('updateCampaign', dataToUpdate)
      },

      updatedSelectedNotification(newTemplate) {
        this.updateCampaign({
          template_id: newTemplate.id
        });
      },

      ...mapActions({
        UPDATE_MESSAGE_ID_TYPE: 'backup/UPDATE_MESSAGE_ID_TYPE',
        UPDATE_BOOLEAN_STATUS: 'backup/UPDATE_BOOLEAN_STATUS',
      })
    },

    created() {
      this.initBackupMessageModule()
    },

    computed: {
      emailWrapperClasses: function () {
        const slideStatus = this.selectedView === 'email' ? 'slide-in' : 'slide-out'
        return 'email-section ' + slideStatus
      },

      smsWrapperClasses: function () {
        const baseClasses = 'message-section scope-wrapper ',
          slideStatus = this.selectedView === 'sms' ? 'slide-in' : 'slide-out',
          highlightClass = this.showBlacklistModal ? ' js-has-word-highlight' : ''
        return baseClasses + slideStatus + highlightClass
      },

      selectedNotificationTemplate() {
        return this.$store.getters.selectedNotificationTemplateFor('message');
      },

      ...mapState({
        showBlacklistModal: state => state.message.showBlacklistModal
      }),
      ...mapGetters(['merchantCountryIsCanada', 'classicCampaignsEnabled','getCampaignNotificationTemplates']),

      ...mapState('message', ['characterCount']),
      ...mapGetters('message', ['totalCredits']),
    },
  }
</script>
